import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connectStore } from "redux-box";
import { module as inviteCode } from "@st/inviteCode";
import { module as product } from "@st/product";
import { module as onboard } from "@st/onboard";
import { module as activity } from "@st/activity";
import Select from "react-select";
import CheckBox from "./CheckBox";
import {
  DropDownContainer,
  DropDownTitle,
  DatePickerContainer,
} from "./SchoolGuidedPathEnable.styled";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  DateSelector,
  DateSelectorIcon,
} from "../../flive-code-view/renewalold-school/RenewalOldSchool.styled";
import { Th, Td, Tr, Table, Grade } from "./SchoolIroEnable.styled";
import { ToolbarItem } from "@sc/Section.styled";


function SchoolGuidedPathEnable(props) {
  const [gradeOption, setGradeOption] = useState([]);
  const [languagesArray, setLanguagesArray] = useState([]);
  const [dropdownProduct, setProduct] = useState("");
  const [serverGradeOption, setServerGradeOption] = useState([]);
  const [schoolGuidedPaths, setSchoolGuidedPaths] = useState([]);
  const [schoolGuidedPathEnableData, setSchoolGuidedPathEnableData] = useState({
    isEnableSchoolGuidedPath: false,
    selectedGrade: [],
    // selectedDate : moment().format("YYYY-MM-DD")
    selectedDate: "",
    custom_lock_unlock: false,
    language: "",
  });

  useEffect(() => {
    let { schoolEditInfo } = props.inviteCode;
    // console.log(schoolEditInfo);
    if (schoolEditInfo) {
      setSchoolGuidedPaths(schoolEditInfo.school_guided_path);
      props.inviteCode.getSchoolGrade(schoolEditInfo.id);
      let langsObj = props.inviteCode.languages.map((lang) => ({
        label: lang.name,
        value: lang.id,
      }));

      setLanguagesArray(langsObj);
      if (schoolEditInfo && schoolEditInfo.school_guided_path && schoolEditInfo.school_guided_path[0]) {
        let isEnable =
          schoolEditInfo.school_guided_path[0].grade_ids.length > 0
            ? true
            : false;
        setServerGradeOption(schoolEditInfo.school_guided_path[0].grade_ids);
        // if (props.inviteCode.languages) {
        // }
        let langObj = langsObj.find(
          (lang) => lang.value === schoolEditInfo.school_guided_path[0].language
        );
        setSchoolGuidedPathEnableData({
          ...schoolGuidedPathEnableData,
          isEnableSchoolGuidedPath: isEnable,
          selectedDate: schoolEditInfo.school_guided_path[0].start_date,
          custom_lock_unlock:
            schoolEditInfo.school_guided_path[0].custom_lock_unlock,
          language: langObj,
        });
        setProduct(
          props.inviteCode.schoolEditInfo.school_guided_path[0].guided_path
            ? props.product.product_list
                .map((pr) => {
                  return { label: pr.name, value: pr.id };
                })
                .filter(
                  (pr) =>
                    pr.value ===
                    props.inviteCode.schoolEditInfo.school_guided_path[0]
                      .guided_path.id
                )[0]
            : ""
        );

        updateSchoolGuidedPathState({
          isEnableSchoolGuidedPath:
            isEnable && !schoolEditInfo.school_guided_path[0].is_deleted,
          selectedDate: schoolEditInfo.school_guided_path[0].start_date,
          selectedGrade: schoolEditInfo.school_guided_path[0].grade_ids,
          guided_path:
            props.inviteCode.schoolEditInfo.school_guided_path[0].guided_path.id,
          custom_lock_unlock:
            schoolEditInfo.school_guided_path[0].custom_lock_unlock,
          language: schoolEditInfo.school_guided_path[0].language,
        });
      }
    }

    return () => {
      props.inviteCode.clearSchoolGuidedPath();
    };
  }, []);

  useEffect(() => {
    if (props.inviteCode.schoolGrade.length > 0) {
      let tempGradeOption = [];
      if (serverGradeOption.length > 0) {
        let tempGradeSelectedOption = [];
        props.inviteCode.schoolGrade.forEach((element) => {
          if (serverGradeOption.includes(element.grade)) {
            tempGradeSelectedOption.push({
              value: element.grade,
              label: element.name,
            });
          } else {
            tempGradeOption.push({ value: element.grade, label: element.name });
          }
        });
        setSchoolGuidedPathEnableData({
          ...schoolGuidedPathEnableData,
          selectedGrade: tempGradeSelectedOption,
        });
        setGradeOption(tempGradeOption);
      } else {
        props.inviteCode.schoolGrade.forEach((element) => {
          tempGradeOption.push({ value: element.grade, label: element.name });
        });
        setGradeOption(tempGradeOption);
      }
    }
  }, [props.inviteCode.schoolGrade, serverGradeOption]);

  const onDatepickerRef = (el) => {
    if (el && el.input) {
      el.input.readOnly = true;
    }
  };

  const updateSchoolGuidedPathState = (data) => {
    /*
            updateSchoolGuidedPathState update the form data as per the server requirement
            so whenever we are updating schoolGuidedPathEnableData value simultaneously need to update redux state as well
            so we can use those value in higher order component
        */
    props.inviteCode.setSchoolGuidedPathFormData(data);
  };

  const handleCheckboxChange = (event) => {
    setSchoolGuidedPathEnableData({
      ...schoolGuidedPathEnableData,
      isEnableSchoolGuidedPath: event.target.checked,
    });
    updateSchoolGuidedPathState({
      isEnableSchoolGuidedPath: event.target.checked,
    });
    props.schoolGuidedPathUpdated();
  };

  const handleCustomLockUnlockCheckbox = (event) => {
    setSchoolGuidedPathEnableData({
      ...schoolGuidedPathEnableData,
      custom_lock_unlock: event.target.checked,
    });
    updateSchoolGuidedPathState({
      custom_lock_unlock: event.target.checked,
    });
    props.schoolGuidedPathUpdated();
  };

  const handleEnableDateChange = (date) => {
    setSchoolGuidedPathEnableData({
      ...schoolGuidedPathEnableData,
      selectedDate: moment(date).format("YYYY-MM-DD"),
    });
    updateSchoolGuidedPathState({
      selectedDate: moment(date).format("YYYY-MM-DD"),
    });
    props.schoolGuidedPathUpdated();
  };

  const handleGradeChange = (event) => {
    if (serverGradeOption.length > 0) {
      let removeItem = schoolGuidedPathEnableData.selectedGrade.filter(
        (x) => !event.includes(x)
      );
      removeItem.forEach((ele) => {
        if (serverGradeOption.includes(ele.value)) {
          setGradeOption([...gradeOption, ...ele]);
        }
      });
    }
    setSchoolGuidedPathEnableData({
      ...schoolGuidedPathEnableData,
      selectedGrade: event,
    });
    let gradeArr = event.map((ele) => ele.value);
    updateSchoolGuidedPathState({ selectedGrade: gradeArr });
    props.schoolGuidedPathUpdated();
  };

  const handleProductChange = (tag) => {
    setProduct(tag);
    updateSchoolGuidedPathState({ guided_path: tag.value });
    // console.log("product selected", tag);
    props.schoolGuidedPathUpdated();
  };

  const handleLanguageChange = (lang) => {
    setSchoolGuidedPathEnableData({
      ...schoolGuidedPathEnableData,
      language: lang,
    });
    updateSchoolGuidedPathState({ language: lang.value });
    props.schoolGuidedPathUpdated();
  };

  const handleEditClick = (data)=>{
    let isDisabled=
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true

    if(isDisabled) return

     let langsObj = props.inviteCode.languages.map((lang) => ({
       label: lang.name,
       value: lang.id,
     }));

    let langObj = langsObj.find(
      (lang) => lang.value === data.language
    );
      setProduct(
        data
          ? props.product.product_list
              .map((pr) => {
                return { label: pr.name, value: pr.id };
              })
              .filter(
                (pr) =>
                  pr.value ===
                  data.guided_path.id
              )[0]
          : ""
      );

      if (props.inviteCode.schoolGrade.length > 0) {
        let tempGradeOption = [];
        if (data.grade_ids.length > 0) {
          let tempGradeSelectedOption = [];
          props.inviteCode.schoolGrade.forEach((element) => {
            if (data.grade_ids.includes(element.grade)) {
              tempGradeSelectedOption.push({
                value: element.grade,
                label: element.name,
              });
            } else {
              tempGradeOption.push({
                value: element.grade,
                label: element.name,
              });
            }
          });
          setSchoolGuidedPathEnableData({
            ...schoolGuidedPathEnableData,
            selectedGrade: tempGradeSelectedOption,
            selectedDate: data.start_date,
            custom_lock_unlock: data.custom_lock_unlock,
            language: langObj,
          });
          setGradeOption(tempGradeOption);
        } else {
          props.inviteCode.schoolGrade.forEach((element) => {
            tempGradeOption.push({ value: element.grade, label: element.name });
          });
          setGradeOption(tempGradeOption);
        }
      }

      updateSchoolGuidedPathState({
        isEnableSchoolGuidedPath:
          true,
        selectedDate: data.start_date,
        selectedGrade: data.grade_ids,
        guided_path:
          data.guided_path.id,
        custom_lock_unlock:
          data.custom_lock_unlock,
        language: data.language,
      });
  }

  return (
    props.inviteCode.schoolEditInfo && (
      <div>
        <div>
          <label>
            <CheckBox
              checked={schoolGuidedPathEnableData.isEnableSchoolGuidedPath}
              onChange={handleCheckboxChange}
              disabled={
                props.inviteCode.schoolEdit
                  ? !props.inviteCode.schoolEdit
                  : true
              }
            />
            <span style={{ marginLeft: 8 }}>Enable Guided Path</span>
          </label>
        </div>
        {schoolGuidedPaths && schoolGuidedPaths.length > 0 && (
          <Table>
            <thead>
              <Tr className="text-center">
                <Th>Product</Th>
                <Th>Grades</Th>
                <Th>Language</Th>
                <Th>Actions</Th>
              </Tr>
            </thead>
            <tbody>
              {schoolGuidedPaths.map((sgp) => {
                let gradesArray = []
                sgp.grade_ids.forEach((grade, index) => {
                  let gradeObj = props.activity.grades.find(
                    (gObj) => gObj.id === grade
                  );
                  gradesArray.push(gradeObj);
                });

                return (
                  <Tr key={sgp.id}>
                    <Td className="text-center">
                      {sgp.guided_path && sgp.guided_path.name}
                    </Td>
                    <Td className="text-center">
                      {gradesArray.map((grade) => grade.name).join(" , ")}
                    </Td>
                    <Td className="text-center">
                      {
                        sgp.language ?
                        props.inviteCode.languages.find(
                          (lang) => lang.id === sgp.language
                        ).name
                        :""
                      }
                    </Td>
                    <Td className="text-center">
                      <ToolbarItem primary onClick={()=>handleEditClick(sgp)}>
                        <div className="icon-container">
                          <i className="fa fa-pencil" />
                        </div>
                      </ToolbarItem>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
        )}
        {schoolGuidedPathEnableData.isEnableSchoolGuidedPath && (
          <div>
            <div style={{ marginTop: 10, marginBottom: 20 }}>
              <h6>Products</h6>
              <Select
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleProductChange}
                placeholder="Select Product"
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                value={dropdownProduct}
                options={
                  props.product.product_list &&
                  props.product.product_list.map((pr) => {
                    return { label: pr.name, value: pr.id };
                  })
                }
              />
            </div>
            <DropDownContainer>
              <DropDownTitle>SCHOOL GRADE</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select school grade"}
                value={schoolGuidedPathEnableData.selectedGrade}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleGradeChange}
                options={gradeOption}
                isMulti={true}
              />
            </DropDownContainer>
            <DropDownContainer>
              <DropDownTitle>LANGUAGES</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select language"}
                value={schoolGuidedPathEnableData.language}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleLanguageChange}
                options={languagesArray}
              />
            </DropDownContainer>
            <DatePickerContainer>
              <h6>Start Date</h6>
              <DateSelector
                style={{ overflow: "hidden", border: "1px solid #a349c9" }}
              >
                <DateSelectorIcon className="fa fa-calendar" />
                <DatePicker
                  selected={schoolGuidedPathEnableData.selectedDate}
                  selectsStart
                  startDate={schoolGuidedPathEnableData.selectedDate}
                  onChange={handleEnableDateChange}
                  minDate={moment().toDate()}
                  placeholderText="Select Enable Date"
                  disabled={
                    props.inviteCode.schoolEdit
                      ? !props.inviteCode.schoolEdit
                      : true
                  }
                  ref={(el) => onDatepickerRef(el)}
                />
              </DateSelector>
            </DatePickerContainer>
            <div style={{ marginTop: "1rem" }}>
              <label>
                <CheckBox
                  checked={schoolGuidedPathEnableData.custom_lock_unlock}
                  onChange={handleCustomLockUnlockCheckbox}
                  disabled={
                    props.inviteCode.schoolEdit
                      ? !props.inviteCode.schoolEdit
                      : true
                  }
                />
                <span style={{ marginLeft: 8 }}>Custom Lock Unlock</span>
              </label>
            </div>
          </div>
        )}
      </div>
    )
  );
}

export default withRouter(
  connectStore({
    inviteCode,
    onboard,
    product,
    activity
  })(SchoolGuidedPathEnable)
);
